module.exports = __webpack_public_path__ + "assets/about_function_08.af86ea75.svg";